module finadai.app.activities.report {
  export var NAME = 'finadai.activities.report';
  class ActivitiesReportController {
    loading = false;
    filters: any = { with: 'agent.user,customer,activity_type', limit: 1000, gtd_created_at: window.moment().subtract(1, 'months').toDate(), ltd_created_at: window.moment().toDate() };
    query = { order: '-created_at._date', limit: 10, page: 1 }
    promise: ng.IHttpPromise<models.http.responses.Records<models.Activity>>;
    activities: models.Activity[];
    agentes: models.Agent[];
    constructor(private customersService: services.CustomersService, $filter, $scope, agentes, private notify) {
      this.filters.status = 'paid';
      this.filters.only_calls = false;
      this.agentes = agentes.data.data;
      this.notify = notify;
    }
    search() {
      this.loading = true;
      var _filters = angular.copy(this.filters);
      _filters.gtd_created_at = _filters.gtd_created_at != null ? window.moment(_filters.gtd_created_at).format('YYYY-MM-DD') : null;
      _filters.ltd_created_at = _filters.ltd_created_at != null ? window.moment(_filters.ltd_created_at).format('YYYY-MM-DD') : null;
      this.promise = this.customersService.getActivities(_filters).then(response => {
        this.activities = response.data.data;
        this.loading = false;        
        return response;
      });
    }
    download() {
      this.loading = true;      
      var _filters = angular.copy(this.filters);
      _filters.gtd_created_at = _filters.gtd_created_at != null ? window.moment(_filters.gtd_created_at).format('YYYY-MM-DD') : null;
      _filters.ltd_created_at = _filters.ltd_created_at != null ? window.moment(_filters.ltd_created_at).format('YYYY-MM-DD') : null;

      this.customersService.downloadActivities(_filters).then(response => {
        this.loading = false;        
        if(response.status == 200){
            this.notify('El archivo ha sido agregado y será procesado en un momento.');
        }
      });
    }
  }
  export function run() {
    var report = angular.module(NAME, []);
    report.controller('ActivitiesReportController', ActivitiesReportController);
  }
} finadai.app.activities.report.run();